import { render, staticRenderFns } from "./edit-form-page.vue?vue&type=template&id=0c9237ca&scoped=true&"
import script from "./edit-form-page.vue?vue&type=script&lang=js&"
export * from "./edit-form-page.vue?vue&type=script&lang=js&"
import style0 from "./edit-form-page.vue?vue&type=style&index=0&id=0c9237ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9237ca",
  null
  
)

export default component.exports